<template>
    <div class="imp_header"  v-if="$route.meta.showHeader">
      <impHeader/>
    </div>
  
    <div class="my_content1">
      <div>
        <router-view class="my_view"></router-view>
      </div>
    </div>
    <div class="imp_footer"  v-if="$route.meta.showFooter">
      <impFooter/>
    </div>

    <back-to-top bottom="200px" right="200px">
      <img class="back-to-top-icon" src="./assets/icon_top.png" alt="">
    </back-to-top>
</template>
<script>
import impHeader from "./views/header.vue"
import impFooter from "./views/footer.vue"

export default {
    name: 'App',
    computed: {
      // 使用对象展开运算符将此对象混入到外部对象中
      // ...mapState([
      //   // 传字符串参数 'collapsed' 等同于 `state => state.collapsed`
      //   'collapsed'
      // ]),
    },
    components: {
      impHeader,
      impFooter,
    },
    data(){
      return{

      }
    },
    created () {
      if(this.isMobile()){
        window.location.href = "/h5/#/pages/index/index"
      }else{ }
    },
    mounted() {

    },
    methods: {
      isMobile(){
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag
      }
    },
}
</script>
<style lang="scss">
.my_view{
  height: calc(100% - 180px)!important;
}
#app{
  height:100%;
}
body{
  // height:100%;
  margin:0;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.imp_header{
  height: 80px;
}
.imp_footer{
  height: 90px;
}
.my_content1{
  // height: 100%;
  min-height: calc(100% - 180px);
}
.back-to-top-icon{
  width: 60px;
  height: 60px;
}
</style>
